import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function PaymentError() {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    // URL parametrelerini kontrol et
    const params = new URLSearchParams(location.search);
    console.log('Ödeme Hatası Parametreleri:', Object.fromEntries(params.entries()));
  }, [location]);

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 4 }}>
      <Box sx={{ 
        textAlign: 'center',
        py: 6,
        px: 4,
        bgcolor: '#fff',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <ErrorOutlineIcon sx={{ 
          fontSize: 64,
          color: 'error.main',
          mb: 2
        }} />
        
        <Typography variant="h5" gutterBottom>
          Ödeme İşlemi Başarısız
        </Typography>
        
        <Typography color="text.secondary" paragraph>
          Ödeme işlemi sırasında bir hata oluştu. Lütfen tekrar deneyiniz.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button 
            variant="outlined"
            onClick={() => navigate('/cart')}
          >
            Sepete Dön
          </Button>
          
          <Button 
            variant="contained"
            onClick={() => navigate('/checkout')}
          >
            Tekrar Dene
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default PaymentError; 